import React, { useEffect, useState } from "react";
import "./style.css"; // CSS que vamos criar

interface CoinDropProps {
  count?: number; // quantas moedas caem
}

const CoinDrop: React.FC<CoinDropProps> = ({ count = 5 }) => {
  const [coins, setCoins] = useState<number[]>([]);

  useEffect(() => {
    const newCoins = Array.from({ length: count }, (_, i) => i);
    setCoins(newCoins);
  }, [count]);

  return (
    <div className="coin-drop-container">
      {coins.map((coin) => (
        <img
          key={coin}
          src="/img/token.png" // coloque aqui o caminho do seu PNG
          className="coin"
          style={{
            left: `${Math.random() * 90}%`, // posição horizontal aleatória
            animationDuration: `${1 + Math.random() * 1.5}s`, // animação aleatória
          }}
          alt="coin"
        />
      ))}
    </div>
  );
};

export default CoinDrop;
